import { Box } from '@mui/material'
import { IncomingChatNotification } from './IncomingChatNotification'
import { useIncomingChatNotifications } from '../hooks/useIncomingChatNotifications'

export const IncomingChatNotificationContainer = () => {
  const { activeNotifications, acceptChat, dismissNotification } = useIncomingChatNotifications()

  if (activeNotifications.length === 0) {
    return null
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 80,
        right: 24,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {activeNotifications.map((notification) => (
        <IncomingChatNotification
          key={notification.notificationId}
          notification={notification}
          onAccept={acceptChat}
          onDismiss={dismissNotification}
        />
      ))}
    </Box>
  )
}
